import React from 'react';

type IconArrowProps = {
    className?: string;
};

export function IconArrow(props: IconArrowProps) {
    const { className = '' } = props;
    return (
        <svg
            className={`${className}`}
            width="49"
            height="37"
            viewBox="0 0 49 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M30.5 35.4141L47.4706 18.4435L30.5 1.47294" stroke="#000000" strokeWidth="3" />
            <path d="M46.5 18.4434L0.5 18.4434" stroke="#000000" strokeWidth="3" />
        </svg>
    );
}

export default IconArrow;
